export const lang = {
  // 頂部巡覽列
  header: {
    sy: '首頁',
    cpjjfa: '產品與解決方案',
    itfw: 'IT服務',
    hzhb: '合作夥伴',
    gyhq: '關於泓齊',
    zzzs: '資質證書',
    jrwm: '加入我們',
    mxyh: '面向銀行的互聯網業務',
    yhxd: '銀行信貸核心系統',
    zlqy: '助力企業營銷新模式',
    hyszh: '行業數字化解決方案',
    jrkj: '金融科技人才輸出',
    qfwrck: '全方位人才庫'
  },
  bottom: {
    tip1: '一家專業為國內外金融機構提供高效技術支持、優質咨詢服務的創新型公司。',
    tip2: '以互聯網金融創新服務為目標，緊跟國家「一帶一路」發展戰略，力求把先進的產品理念、精湛的技術和良好的服務帶給全球客戶。',
    tip3: '微信掃一掃關註我們',
    tip4: '產品與解決方案',
    tip5: '數字人民幣',
    tip6: '區塊鏈',
    tip7: '跨境收款',
    tip8: '海外支付',
    tip9: '聯系我們',
    tip10: '聯系方式',
    tip11: '郵箱',
    tip12: '官網',
    tip13: '深圳總部',
    tip14: '香港分公司',
    tip15: '張家口分公司',
    tip16: '西安分公司'
  },
  gotop: {
    d: '頂',
    b: '部'
  },
  // 首頁
  HellowWorld: {
    yljr: '引領金融科技創新走向世界',
    yljr1: '秉承“安全、高效、優質”的',
    fzzz: '發展宗旨',
    xxjs: '求金融行業信息技術',
    yycx: '應用創新',
    zlycw: '致力於成為全球金融科技行業服務價值的',
    czz: '創造者與領先者',
    lxwm: '聯系我們',
    bc: '秉承',
    aqgx: '安全、高效、優質',
    fzzz1: '的發展宗旨',
    wyh: '為銀行',
    lsdzd: '量身打造的',
    fwpt: '跨境交易服務平臺',
    whzrwt: '精準解決外匯轉入問題',
    jybkd: '進一步擴大外匯業務範圍，',
    jskthw: '加速開拓海外市場提供有力、穩定的系統支持',
    text1: '深度場景賦能，構建您的',
    text2: '數字化戰略',
    text7: '平臺優勢',
    text8: '引領',
    text9: '金融科技創新',
    text10: '走向世界',
    text11: '解決方案',
    text12: '滿足您的',
    text13: '個性化需求',
    text14: '咨詢規劃',
    text14_tip: '明確發展願景,融合自身優秀實踐經驗和先進技術,深耕金融行業方法論',
    text15: 'IT實施',
    text15_tip: '全面、可靠、高效的IT團隊，助力發展願景變為現實',
    text16: '本地化服務',
    text16_tip: '產品合規、多語言專家團、一對一本地IT隊團隊，助您快速了解全球市場',
    text17: '綜合數字化營銷解決方案',
    text17_tip: '全方位數字化營銷服務 、本地化內容輸出建議 、精準定位不同受眾差異 、大數據結合成效驅動分析',
    text18: '來自',
    text19: '各行業的',
    text20: '優秀實踐',
    text21: '與我們合作',
    text22: '3年',
    text23: '金融核心系統',
    text24: '我們很享受HQ PAY專業的指導，他們豐富的從業經驗、專業且獨特的規劃建議、高執行力的實施團隊幫助我們在短時間內搭建出適合我們、穩定運行的互聯網金融核心系統。期待在與HQ PAY持續的合作中不斷叠代我們現有系統的功能。',
    text25: '營銷方案',
    text26: '我們享受一直以來與HQ PAY的合作。HQ PAY的專家團隊對數字營銷領域的知識豐富且專業，他們有效的策略及IT團隊高效的執行力讓我們的項目按期落地，也讓我們的營銷活動取得極大成效。HQ PAY團隊專業高效的能力讓我們印象深刻，他們用實力得到我們的信賴。',
    text27: '數字化渠道解決方案',
    text28: '在我們與HQ PAY合作的這些年裏，HQ PAY在每個新項目中都能給我們帶來驚喜。這次的數字化解決方案，HQ PAY為我們量身打造了多層次、多維度、全方面的數字化重塑方案，深度賦能了我司構建具有前瞻性的全渠道數字化業務模式。期待與HQ PAY在即將開展的新項目中的表現！',
    text29: '全球支付',
    text30: '聚合的全球範圍內支付解決方案',
    text31: '助力銀行與全球商戶、消費者無縫對接',
    text32: '深耕全球差異化產品和服務',
    text33: '數字人民幣',
    text34: '搶占萬億級移動支付市場',
    text35: '不受網絡限製，雙離線仍可支付',
    text36: '國家信用，任何機構和個人不得拒收',
    text37: '區塊鏈',
    text38: '移動支付的',
    text39: '下一個風口',
    text40: '顛覆傳統支付業的',
    text41: '‘中心’',
    text42: '安全、加密、強可溯',
    gjdq: '國家地區',
    zjtd: '專家團隊',
    jrjg: '金融機構',
    zcyy: '支持語言',
    ywcp: '業務產品',
    zdpp: '眾多客戶的一致認可',
    wxsm1: '微信掃碼',
    popup1: '您好！',
    popup2: '完善您的信息，讓我們更好的為您服務',
    popup3: '您的姓名',
    popup4: '請輸入您的姓名',
    popup5: '您的郵箱',
    popup6: '請輸入您的郵箱',
    popup7: '您的聯系方式',
    popup8: '請輸入您的聯系方式',
    popup9: '提交',
    wgnw: '為國內外金融機構提供',
    gxjs: '高效技術支援、優質諮詢服務',
    lqb: '力求把',
    xjcp: '先進的產品理念',
    jzjs: '精湛的技術',
    lhdfw: '良好的服務',
    qqkh: '帶給全球客戶',
    yhzd: '用戶主動出示自己付款條碼',
    sjzj: '商家直接掃描即可完成付款',
    djdj: '對接多家銀行、協力廠商支付公',
    zcdj: '司，支持多級商戶體系',
    zhsm: '整合市面所有的支付通道，全',
    lghz: '力給合作方提供多途徑通道',
    lyfw: '旅遊服務',
    lyfwjs: '整合旅游資源，貼合線下場景，把吃、住、行、遊、購、娛等各項商家服務融合，形成有效閉環',
    shfw: '生活服務',
    shfwjs: '物業繳費系統集成了業主和租戶繳費以及物業相關管理繳費以及銀行管理統計，增加便利提升安全',
    zncy: '智能餐飲管理系統',
    zncyjs: '智能餐飲管理系統集成了消費者點餐-服務台接單-後廚接單處理以及事後的統計分析，大大提升工作效率',
    wgfw: '網購服務',
    wgfwjs: '新零售電商平台系統開發解決方案、從單一零售向多元（商品+服務+內容+其他）轉化，讓線下線上相融合，推動企業轉型升級',
    jrfw: '金融服務',
    jrfwjs: '互聯網金融平台的建設，打破原有封閉體系，幫助銀行轉型，融入互聯網生態',
    ylfw: '醫療服務',
    ylfwjs: '統一信息流轉與通訊大平台，打通醫療環節中的各種參與者，各系統、終端，實現互聯網互通，促進信息充分流通',
    yizf: '移動支付',
    hlwzf: '互聯網支付',
    kjzf: '跨境支付',
    tysh: '統一商戶平臺',
    hwdz: '海外電子錢包支付',
    tyfx: '統一分銷平臺',
    xyfk: '信用風控決策模型',
    znkf: '智慧客服模型',
    jzyx: '精准行銷模型',
    dhcs: '貸後催收模型',
    dsjy: '電商交易平臺',
    dzyf: '電子預付卡交易平臺',
    wltz: '網路投資平臺',
    wlxf: '網路消費分期信貸平臺',
    tyyx: '統一行銷平臺',
    jfyh: '積分優惠券管理系統',
    zcgl: '資產管理系統',
    zncygl: '智慧餐飲管理系統',
    wyjf: '物業繳費系統',
    sbjf: '社保繳費系統',
    jyjf: '教育繳費系統',
    zjzh: '資金帳戶存管',
    hlwjr: '互聯網金融平臺',
    ydzf: '移動支付收單（跨境&本地錢包）',
    jhzf: '聚合支付收單系統',
    wygl: '物業管理系統',
    jyzx: '教育線上繳費系統',
    hlwty: '互聯網統一電子帳戶系統',
    jpz: '柬埔寨電子錢包系統',
    hlwtrz: '互聯網投融資服務平臺',
    zncyxt: '智慧餐飲系統',
    shdzhyk: '商戶電子會員卡管理系統',
    ljxq: '瞭解詳情',
    cgal: '成功案例',
    hqwlkj: '深圳市泓齊網路科技有限公司',
    gsdh: '公司電話：',
    gsyx: '公司郵箱：',
    gswz: '公司網址：',
    gsdz: '公司地址 :廣東省深圳市南山區桃源辦平山大園 工業區13棟（鴻萊科創樓）4樓405室',
    wxsm: '微信掃碼關注我們',
    beian: 'Copyright2017-2018 深圳市泓齊網路科技有限公司',
    beian2: '粵ICP備18002099號-1'
  },
  // 加入我们
  joinUs: {
    t1: '和我們一起，讓進步發生',
    t2: '期待',
    t3: '你的加入',
    t4: '營銷運營類',
    t5: '技術類',
    t6: '職能類',
    t7: '管理類',
    t8: 'IOS開發工程師',
    t9: 'Android開發工程師',
    t10: 'WEB前端開發工程師',
    t11: 'Java開發工程師',
    t12: '測試工程師',
    t13: '架構工程師',
    t14: '運維工程師',
    t15: '互金產品經理',
    t16: '市場銷售',
    t17: '銷售顧問',
    t18: '人力資源招聘主管',
    t19: '招聘專員',
    t20: '行政專員',
    t21: '部門主管',
    t22: '項目經理',
    t23: '1、全日製大專或以上學歷，1年以上軟件 測試經驗，熟悉測試工作流程，能製訂測試計劃、測試方案、有項目實踐經驗；',
    t24: '2、能獨立承擔項目軟件測試；',
    t25: '3、了解主流數據庫，如MySQL、SQL Server等；',
    t26: '4、能快速熟悉內部管理系統的各模塊作用和使用方法；',
    t27: '5、學習能力強、責任心和主動性強，有良好的溝通表達能力及團隊協調能力；',
    t28: '6、有ERP測試項目經歷優先',
    t29: '1、精通java，熟練AIDL、NDK開發，深入理解面向對象的設計思想，常用設計模式；',
    t30: '2、精通Android開發，了解Android框架對Android系統應用管理、進程管理、內存管理等機製有深入理解；',
    t31: '3、對APP性能優化方面有獨到見解；',
    t32: '4、工作年限要求：5年以上。',
    t33: '1、熟練使用各種前端技術，有可視化搭建經驗、豐富的CMS開發經驗、對智能化前端有實踐者最佳，能獨立主導和推動落地復雜的前端架構設計。',
    t34: '2、具備跨端的前端開發能力，在Web（PC+Mobile）/Node.js/Native App三個方向上至少精通兩個方向，鼓勵在「效能提升，技術架構升級，多端技術融合」上的探索。',
    t35: '3、對前端工程化與模塊化開發有較深了解，並有豐富實踐經驗。',
    t36: '4、至少精通一門非前端的語言（如Node/Java/C/C++等），並有實踐經驗。',
    t37: '5、具備良好的團隊協作精神，能利用自身技術能力提升團隊影響力，具有團隊管理經驗最佳，能夠主動帶領身邊同事共同進步。',
    t38: '6、對前端技術有持續的熱情，個性樂觀開朗，邏輯性強，善於和各種背景的人合作。',
    t39: '1、熟悉應用系統調優、JVM調優手段，有良好的設計模式與思維；',
    t40: '2、熟練使用 Spring，SpringMVC，iBatis等開發框架，熟悉Tomcat等開源服務器；',
    t41: '3、熟練MySQL、Redis，對NoSQL存儲技術有一定的了解，具備數據庫優化能力；',
    t42: '4、對微服務架構體系有較為深刻的理解；',
    t43: '5、工作年限要求：3年以上。',
    t44: '1、本科及以上學歷，計算機相關專業，參與過中大型項目測試工作優先；',
    t45: '2、具備3年左右軟件測試經驗，熟悉常見軟件測試流程和規範，熟練掌握軟件測試方法，掌握測試設計理論；',
    t46: '3、熟練使用常用測試工具，了解缺陷管理過程，有Java/Python代碼基礎，熟悉TCP/HTTPS等網絡協議，熟悉MySQL等數據庫相關操作；',
    t47: '4、了解前端技術，熟悉android、iOS系統app測試；',
    t48: '5、良好的溝通和理解能力，有親和力，工作認真、細心、服從工作安排，有良好的團隊合作精神和敬業精神。',
    t49: '1、全日製統招本科及以上學歷，計算機相關專業，3年以上架構設計與開發經驗；',
    t50: '2、有高並發、分布式、高可用設計和開發的實踐經驗， 至少主導過一個大型平臺的架構設計和開發；',
    t51: '3、精通java/J2EE開發，熟悉Spring Cloud框架；',
    t52: '4、熟悉和掌握主流的數據庫和中間件件技術，如MySql、Redis、Memcached、Kafka、RabbitMQ等；',
    t53: '5、良好的邏輯思維能力，熟悉業務抽象和數據模型設計，具有很強的分析問題和解決問題的能力，對解決具有挑戰性問題充滿激情；',
    t54: '6、良好的溝通能力，有團隊合作精神和責任感。',
    t55: '1、熟悉Oracle、MySQL數據庫及體系架構，可以獨立安裝部署數據庫，對數據庫進行物理和邏輯備份；',
    t56: '2、熟悉Oracle、DataGuard高可用架構，可以獨立搭建部署ADG；',
    t57: '3、熟悉MySQL，主从复制和MGR高可用架构，可以独立部署；',
    t58: '4、工作年限要求：3年以上。',
    t59: '1、4年以上產品經理工作經驗，本科或以上學歷，金融或計算機專業優先考慮；',
    t60: '2、有銀行系統產品設計經驗，有銀行金融工作經驗者優先，對銀行核心系統及產品有深入理解；',
    t61: '3、熟悉產品實施過程，包括需求分析，產品設計、流程設計、界面設計和可用性測試等；',
    t62: '4、工作年限要求：4年以上。',
    t63: '深圳市泓齊網絡科技有限公司（總公司）',
    t64: '廣東省深圳市南山區西麗街道石鼓路深圳萬科雲城國際創新谷3期7棟C座502',
    t65: '深圳市泓齊網絡科技有限公司（張家口公司）',
    t66: '河北省张家口市万全区孔家庄镇民主街区医院西底商二楼',
    t67: '公司地址',
    t68: '深圳市泓齊網絡科技有限公司（西安公司）'
  },
  // 產品與解決方案
  ProductSolutions: {
    index: {
      cpyjjfa: '產品與解決方案',
      xydzf: '新一代支付',
      dsjfx: '大資料分析',
      hlwjr: '互聯網金融',
      zhxd: '綜合信貸',
      szhyxfw: '數字化營銷服務',
      szhcj: '數字化場景',
      yhhyjjfa: '銀行行業解決方案',
      kjjr: '跨境金融',
      jryw: '金融業務',
      hxjr: '核心金融'
    },
    kjskxt: '跨境收款系統',
    tips1: '助力企業加速開拓海外市場提供有力的系統支持',
    kjzfxt: '跨境支付系統',
    tips2: '提供移動化、智能化、雲化的聚合支付平臺',
    hwxnkglxt: '海外虛擬卡管理系統',
    tips3: '通過電子渠道申請開立的無實體介質的虛擬借記卡',
    hwyckhxt: 'E-KYC海外遠程開戶系統',
    tips4: '使用先進的專有反欺詐算法進行真人身份驗證',
    qklxt: '區塊鏈及web3系統',
    tips5: '基於雲區塊鏈服務創建、部署的區塊鏈技術平臺服務',
    fxqxt: 'AML反洗錢系統',
    tips6: '為銀行構建靈活、機敏、高可靠的反洗錢信息監測系統',
    sjyhjwyxt: '手機銀行及網銀系統',
    tips7: '一對一貼身打造手機銀行APP及網銀系統',
    dzqbxt: '電子錢包系統',
    tips8: '集成豐富的增值應用，讓支付不止於‘付’',
    szrmb: '數字人民幣',
    tips9: '為銀行量身打造數字人民幣系統',
    hlwhxxt: '互聯網核心系統',
    tips10: '互聯網豐富的場景創新、產品創新、快速叠代提供功能支撐',
    zjtgxt: '資金托管系統',
    tips11: '為各類交易平臺提供賬戶管理，收付款，結算對賬等交易服務',
    dwqlczhxt: '大灣區理財綜合系統',
    tips12: '助力銀行促進大灣區跨境投資便利化',
    tips13: '先買後付，打開購物新天地',
    wlxf: '網絡消費分期及現金貸服務',
    tips14: '基於互聯網的純信用貸款業務',
    xdsplc: '信貸審批流程管理系統',
    tips15: '可根據業務類型靈活設置審批風控流程。',
    fkjcmx: '風控決策模型',
    tips16: '結合線上、線下海量數據構建信用風險體系',
    dhcs: '貸後催收模型',
    tips17: '為金融機構量身定製的一款成熟的催收業務管理系統',
    xcxkf: 'APP及小程序開發',
    tips18: '一站式軟件、小程序設計開發服務',
    zmjtgxt: '招募及推廣系統',
    tips19: '為團長營銷量身打造',
    hlwqdyx: '互聯網渠道營銷平臺',
    tips20: '適用於出行、外賣、電影票、視頻、遊戲、加油卡等服務場景',
    zhjfglxt: '綜合積分管理系統',
    tips21: '一站式場景生活權益服務',
    qyhx: '權益核銷SaaS服務平臺',
    tips22: '適用於出行、外賣、電影票、視頻、遊戲、加油卡等服務場景',
    hyyf: '會員預付卡管理系統',
    tips23: '互聯網玩專業會員卡綜合服務商助力商戶效益提升',
    dszhjypt: '電商綜合交易平臺',
    tip24: '集團購、電商零售、批發於一體，幫助企業低成本快速構建網上商城系統',
    jyjfglxt: '教育繳費管理系統',
    tips25: '依托微信體系建設的教育繳費平臺',
    wyglxt: '物業管理系統',
    tips26: '“智慧物業” 綜合信息服務平臺',
    zycf: '中央廚房餐飲配送系統',
    tips27: '借助大數據雲服務為中央廚房量身定製全流程的解決方案',
    jrkjrcsc: '金融科技人才輸出',
    tips28: '構建企業人才庫,為企業提效降本',
    BankingIndustrySolutions: {
      zncy: '智慧餐飲管理系統',
      jyjf: '教育繳費系統',
      wyjf: '物業繳費系統',
      zjzh: '資金帳戶存管',
      sbjf: '社保繳費系統',
      yhzj: '銀行中間服務',
      hlwjr: '互聯網金融平臺',
      AccountFunds: {
        zjzh: '資金帳戶存管',
        zjzhdy: '資金帳戶存管定義',
        wljd: '網路借貸資金存管業務，是指商業銀行作為存管人接受委託人的委託，按照法律法規規定和合同約定，履行網路借貸資金存管專用帳戶的開立與銷戶、資金保管、資金清算、賬務核對、提供資訊報告等職責的業務。存管人開展網路借貸資金存管業務。',
        cptd: '產品特點',
        yejs: '業務介紹'
      },
      EducationPayment: {
        jyxt: '教育系統解決方案',
        jyhy: '教育行業收費現狀',
        xxsf: '學校收費具有收費群體大，收費時間集中，收費資料大等特點，由於學校財務人員有限，工作量大的問題較為突出；面臨的物件群體大，收費群體的變動性強，同時收費專案具有多樣化，財務人員無法精確掌握每個收費物件的繳費狀況；面對龐大的收費群體及多樣化的收費專案，財務人員無法在有限時間內對資料進行分類統計核算，耗時耗力效率低',
        jyfy: '教育費用需手動收取，費時費力,少量線上收取,無法為異地的家長提供收費管道；傳統櫃檯收取現金，收費後不能與實際收款費對應需要財務人員進行二次核對核銷；學生調動班級後，跟蹤學生的繳費情況困難；手動收取人員成本較高；收取後現金管理成本高；收取後現金管理成本高，存在資金風險；多年級多班級多個不同科目收費後歸集難，收費包含多項內容，需要人工清分至不同帳戶。',
        hqwk: '泓齊網科教育系統產品簡介',
        jfyq: '繳費延期不用到場，可以使用手機APP查詢紀錄和繳費；通過電子化手段，降低人工投入成本、設備耗材投入成本等運營成本；電子精准扣費，杜絕逃費、漏費情況；減少由於人工收費導致的問題(假幣、錯收、漏收)；雲平臺管理，大資料分析，説明管理方掌握各種資訊，拓展更多服務；客戶提供更多擴展智慧化的服務，網路充值、預定車位等；開放的資料介面，應用更便捷',
        fb: '方便、快捷',
        jysj: '節約時間、成本',
        aq: '安全，高效',
        tz: '拓展',
        lcsyt: '泓齊網科教育系統核心場景業務流示意圖',
        ewm: '二維碼為載體',
        yxx: '以學校為單位為每一班級生成一個專屬二維碼該二維碼可貼至學校門口、班級內、發送給在外地的家長用任意工具掃取後進入收費頁面，直接交費即可',
        ygzh: '以公眾號為窗口',
        wyw: '為業務提供微信公眾號、支付寶服務窗服務家長可在該入口獲取相應的家長服務',
        xih: '資訊化為根本',
        dtxx: '打通學校管理系統與收費系統通過資訊化、移動互聯網化的方案突破收費的時空限制通過技術手段降低人工核銷對賬的難度與成本'
      },
      IntermediateBankService: {
        zjyw: '中間業務平臺解決方案',
        cpdy: '產品定義',
        szwg: '隨著我國金融業改革的不斷深入發展，各銀行間的競爭也日趨激烈，利用技術、資訊、機構網路、信譽等種種優勢，積極拓展中間業務服務，對我國商業銀行具有十分重要的戰略意義。建立開放性好、可擴展性強、新業務開發快捷、系統運行穩定和維護簡便的銀行中間業務平臺，將成為銀行大力發展中間業務的有效手段。泓齊中間業務平臺是一套統一的中間業務交易處理和協力廠商介面管理的系統平臺，它支援保險、證券、稅務、財政以及各類代繳費單位的統一接入和業務處理。該平臺採取基於分散式的技術架構，有效得區分各業務的處理。',
        ywjs: '業務介紹',
        ywbk: '業務包括對公代理（代發工資、補貼等），代繳水電煤，財政非稅管理、法院查凍扣，反電信詐騙管理，招標辦保證金管理等。'
      },
      InternetBanking: {
        zjyw: '中間業務平臺解決方案',
        cpdy: '產品定義',
        hlwjr: '互聯網金融平臺（ITFIN）網路借貸模式在服務小微企業方面有著獨特的優勢。小微企業主以個人名義，通過仲介獲得融資，既能做到方便快捷，又能有效利用社會閒散資本，再加上機構通過網路能有效降低服務成本，符合小微企業需求。P2P網路借貸平臺指個人與個人間通過網路平臺達成的小額借貸交易。借款者可自行發佈借款資訊，包括金額、利息、還款方式和時間，實現自助式借款;借出者根據借款人發佈的資訊，自行決定借出金額，實現自助式借貸。',
        ywjs: '業務介紹',
        ptdjs: '互聯網金融平臺的建設，打破原有的封閉體系，幫助銀行轉型，融入互聯網生態。'
      },
      PropertyPayment: {
        wygl: '物業管理系統解決方案',
        sfxz: '物業管理收費現狀',
        rjd: '如今的物業管理，多以傳統櫃檯收取,少量線上收取,無法為遠端不在家的業主提供收費管道；傳統櫃檯收取現金，收費後不能與實際物管費對應需要財務人員進行二次核對核銷，電匯交費後，無法與實際物管費對應，需要財務人員進行二次核銷。櫃檯收取人員成本較高，收取後現金管理成本高，傳統線上收取方式業主接受難度大，成本高；多個不同物業收費後歸集難，收取物業費包含多項內容，需要人工清分至不同帳戶。大多數物業管理服務公司收費率只能達到50%-70%左右，有的甚至只有30%，傳統櫃檯收費模式人工成本高，無法及時有效地將發生的物業費推送給業主及時收費。',
        sqfs: '收取方式單一',
        sffs: '收費方式成本過高',
        sfh: '收費後對賬難',
        gj: '歸集清分難',
        cpjs: '泓齊網科物業管理系統產品簡介',
        jfyq: '繳費延期不用到場，可以使用手機APP查詢紀錄和繳費；通過電子化手段，降低人工投入成本、設備耗材投入成本等運營成本；電子精准扣費，杜絕逃費、漏費情況；減少由於人工收費導致的問題(假幣、錯收、漏收)；雲平臺管理，大資料分析，説明管理方掌握各種資訊，拓展更多服務；客戶提供更多擴展智慧化的服務，網路充值、預定車位等；開放的資料介面，應用更便捷',
        hlw: '互聯網、方便、快捷',
        jysj: '節約時間、成本',
        aq: '安全，高效',
        tz: '拓展',
        ywsyt: '泓齊網科物業管理系統核心場景業務流示意圖',
        ewm: '二維碼為載體',
        ewmjf: '二維碼交費：物業公司將每戶專屬二維碼發放給物業，業主/租客在家掃碼即可交費',
        gzh: '以公眾號為窗口',
        wyw: '為業務提供微信公眾號、支付寶服務窗服務業主/租客可在銀行/物業公司的公眾號點擊鏈進行交費',
        xxh: '資訊化為根本',
        dtwy: '打通物業管理系統與收費系統通過資訊化、移動互聯網化的方案突破收費的時空限制通過技術手段降低人工核銷對賬的難度與成本'
      },
      SmartCatering: {
        xtjj: '泓齊點餐系統簡介',
        zzdc: '泓齊自助點餐管理系統是本公司經過對現今餐飲行業及行業將來發展趨勢進行深入調查，結合眾多酒樓餐飲行業客戶管理需求以及食客現今的就餐習慣，由本公司專業技術開發團隊潛心開發，全力打造的一款面向中餐、西餐、海鮮酒樓、特色餐廳酒樓的餐飲管理系統。系統操作簡單，功能齊全，能幫助您的餐廳酒樓利用電腦強大的資料處理能力和流程優化能力，實現自動化管理，簡化餐廳的工作管理流程，減少浪費及人為管理的疏漏現象，優化酒樓的管理資源提高整個餐廳的運作效率。系統對菜品的各類做法及顯示有很好的支援功能，支援臨時菜品、套裝菜品。',
        cptd: '產品特點',
        hybj: '行業背景及自助點餐機的誕生',
        xjd: '現階段的餐飲行業一直保持著高速增長的態勢，已成為了世界消費需求市場中增長幅度最高、發展速度最快的行業之一。而在當前餐飲行業日趨激烈的競爭中脫穎而出，是每一位餐飲業經營者所追求的目標。自助點餐機也正是在這樣的背景之下走進了餐飲行業。',
        szkj: '隨著科技的發展，不斷降低的硬體成本、不斷進步的技術，都在推動著自助點餐機不斷地推陳出新，我們相信，自助式點餐模式必將成為餐飲服務行業的一個發展趨勢，成為引領餐飲市場前進的完整形主流科技產品',
        dcj: '點餐機的設計理念',
        cyhy: '⑴令餐飲行業全面進入自助式服務時代傳統的人工點餐，會因客人及服務人員的語言，態度，功能表上菜品更新不及時，或者是其它的某種原因，造成某種不必要的麻煩及糾紛，而採用自助式點餐服務之後，在某種程度上可以有效的杜絕這些無必要的糾紛及麻煩，同時，讓服務員騰出更多精力，從而更優質為顧客服務。令企業與客人雙方都能享受到舒適便捷的服務就餐模式，這將是餐飲業發展的最終趨勢。',
        ydcy: '⑵引導餐飲行業資訊技術化的變革在科技的時代，自助點餐機不僅科學地縮短了食客點單、下單、買單的流程、避免了人為失誤；而且還提供了多種管理模式，如：倉儲管理，報表管理，會員管理，資訊採集更新，買單折扣優惠等功能，相比傳統的人工管理，使用自助點餐機將大大減輕人力投入，我們相信自助點餐機的出現將帶動一場資訊化點單理念的革命。技術變革，勢在必行！',
        rjyd: '軟體優點',
        xtsy: '系統適用範圍',
        zcjl: '中餐酒樓、海鮮餐廳酒樓、特色酒樓、連鎖餐飲企業',
        zncy: '智慧餐飲管理系統流程',
        xfzdc: '消費者點餐',
        ctsm: '餐台掃碼點餐：消費者可掃取桌面二維碼點餐遠程點餐：消費者可在互聯網直接訂桌，點餐',
        hcjd: '後廚接單',
        xdgl: '後廚可根據下單情況，備菜',
        fwtjd: '服務台接單',
        jdgl: '接單管理：服務員可隨時管理訂單、買單等操作',
        tjfx: '統計分析',
        yyksh: '運營可事後根據歷史訂單情況進行統計分析，為後續備料，增加翻太台率提供依據',
        jscb: '①為業主節省成本，拓展利潤',
        gnws: '②功能完善，適用性強',
        cbfx: '③為餐飲行業經營者提供了成本分析，利潤分析，倉儲管理等諸多功能',
        czjd: '④圖形化介面，操作簡單，無需專業培訓即可正常使用'
      },
      SocialSecurityPayment: {
        sbgl: '社保管理系統解決方案',
        wsb: '“微社保”人臉識別系統，是聊城農商銀行與東昌府區人社局強化戰略合作，針對轄區廣大職工群眾，推出的一款“便民服務”產品；該系統依託人社局社保資訊資料庫，借助騰訊人臉識別技術，通過對人臉識別驗證，對參保人員的身份進行確認。目前，“微社保”系統已對東昌府區參保人員實現了全覆蓋。',
        yyzd: '“微社保”上線意義重大：一是方便了參保職工群眾。在東昌區參加社保的群眾，不用到人社局進行現場認證，只要手機關注一下APP，在較短的時間內，即可完成“線上認證”，讓群眾切實體驗到“極簡金融服務”；該系統打破了社保資格認證的時間、空間和地域限制，極大了方便了行動不便的老人、異地工作人員，免去了路途奔波之苦。二是提升了社保管理水準。社保局通過“微社保”管理系統，可精准查詢人臉認證的結果，及時更新、維護社保人員資訊資料庫。另外，不再需要組織現場認證和張榜公示，極大地提高了社保機構的工作效率、降低了管理成本；也對“冒領社保資金”不法行為築起了一道堅實的“防火牆”。'
      }
    },
    BigData: {
      znkf: '智慧客服模型',
      jzyx: '精准行銷模型',
      xyfk: '信用風控決策模型',
      dhcs: '貸後催收模型',
      CreditriskControl: {
        xyfktd: '信用風控特點',
        dq: '當前，經濟下行導致中小企業經營成本不斷增加，產品銷售價格因結構原因和市場原因相對走低，企業利潤空間被進一步壓縮，許多中小企業陷入經營困境，導致企業經營風險加大、連鎖性風險陡增、潛在信用風險上升、企業主的道德風險陡升，與此同時經濟下行也使得個人信貸中的逾期率陡增，不良貸款率上升。',
        yy: '運用金融物理學原理和機器學習方法，基於大資料分析技術實現智慧化、全面量化風險管理和輔助決策。',
        fxmn: '風險模擬',
        fxdt: '風險動態',
        jk: '監控',
        fxle: '風險類型',
        sb: '識別',
        yjfx: '預警風險',
        dlfx: '度量風險',
        xyfk: '信用風控',
        xyfklc: '信用風控流程',
        shcj: '資料獲取',
        gzgl: '規則管理',
        dcfx: '調查分析',
        algl: '案例管理',
        bbfx: '報表分析',
        xyfkzb: '信用風控指標',
        qyzb: '企業指標',
        cwzb: '財務指標',
        hgzb: '宏觀指標',
        hyzb: '行業指標',
        grzb: '個人指標',
        hg: '　宏觀　',
        hy: '　行業　',
        gr: '　個人　',
        zbpl: '指標頻率',
        rdzb: '日度指標',
        ydzb: '月度指標',
        jdzb: '季度指標',
        ndzb: '年度指標'
      },
      LoanCollection: {
        dhcs: '貸後催收',
        zdhlw: '是針對互聯網金融行業、P2P網貸系統、傳統小貸行業、網路投融資平臺以及銀行信用卡業務的貸後催收管理退出的完整催收解決方案，結合移動智慧終端機方便外放催收，滿足銀行對催收過程監管的要求，在系統部署安全能力、網路完全管控、資料安全管控等方面均有高標準，保障催收業務安全、規範、各部門協調有序工作。',
        dhcsgn: '貸後催收-功能',
        jck: '貸後催收-決策庫',
        jcblk: '決策變數庫',
        khxx: '客戶資訊',
        zhxx: '帳戶信息',
        jyxx: '交易資訊',
        cslc: '催收歷程',
        ajfl: '案件分類、逾期階段、風險等級、案件狀態',
        yqcs: '近6月累計逾期次數、近6月最大逾期CD、近3月BP次數、···',
        yqts: 'CD、逾期天數、餘額最低還款額、本金、餘額額度比、···',
        csm: '城市碼、產品碼、性別、學歷、VIP、···',
        sjzh: '數據整合',
        csxt: '催收系統和業務系統、征信介面、資料倉庫等系統或介面進行資料交互，保證催收系統內部資料的完整性',
        lczh: '流程整合',
        csdl: '催收佇列對不同的催收手段如電話催收，上門催收、發物催收、外包催收、電郵等進行工作的流程',
        qdzh: '管道整合',
        dxxt: '催收系統和短信系統、電郵系統、客服系統、進行資料交互，保證催收管道的完整性',
        htzc: '後臺支撐',
        sjfw: '催收系統在設計發物計算的部分提供參數設置支撐，提供即時的監管功能和豐富的報表體系對業務發展提供支撐',
        fxgl: '風險管理',
        pdtx: '催收系統應有完善的風險判定體系，能對逾期帳戶進行多個維度的帳戶劃分和狀態界定，並通過規則處理形成特定的催收佇列'
      },
      PrecisionMarketing: {
        jzyy: '精准行銷-特點',
        yrwb: '以人為本是精准行銷的發展趨勢，把個體變為行銷的核心，尤其是多中心的個體形成的關係網絡行銷，以帶動更多的體驗行銷、口碑行銷和社群行銷，將互聯網上社會化網路服務轉化為生產力。',
        xyx: '行銷行為效益性',
        yxx: '行銷策略有效性',
        zdx: '目標物件針對性',
        wdx: '目標物件穩定性',
        zsgl: '知識管理',
        dgc: '的過程',
        ff: '精准行銷-方法',
        sjsj: '通過資料收集，基於通信行為、上網資料等，可對客戶行為特徵進行解析，通過對資訊進行關聯、參照、聚類、分類等方法分析，得到有價值的用戶行為',
        tzjz: '通過客戶行為特徵機制，作為客戶分析的基礎。可以通過手機和整理開放式分類目錄、各大行業主流網站、熱門門戶網站以及參考互聯網分類行業標準來制定。同時建立行為特性調整的動態機制',
        swcs: '基於用戶上網次數、流量、時間段等屬性，可以給使用者增添標籤；針對上網較少的使用者，可以通過基礎資料特徵(如年齡、性別、流量、終端等基礎資料，使用資料採擷工具和方法生成對應模型',
        khtzfx: '客戶特徵分析',
        sr: '年齡、地域、學歷、婚姻、職業、收入',
        lrlfx: '利潤率分析',
        gdjz: '通過分析哪些客戶能產生更大的利潤商品具有更多的利潤率，找更大價值商品或服務，為企業創造更多價值',
        qxfx: '消費傾向分析',
        xfxq: '瞭解客戶消費興趣，分析行為習慣、對不同客戶的需求提供具有個性化、差異性的服務，並以研發、生產、銷售有針對性的產品或服務，以達到企業與消費者都能獲取利益和滿足',
        zcdfx: '客戶忠誠度分析',
        lzkh: '運用行銷手段留住客戶，深度挖掘潛在客戶，分析客戶感興趣程度，使之成為回頭客，利用回頭客拉動新客戶、完善客戶群體，並預測如何提高客戶的忠誠度的途徑，為企業創造更大的發展空間',
        xwfx: '消費行為分析',
        srfx: '對客戶消費行為所產生的資料進行深入分析，找出更有利用價值的關鍵客戶資訊，並制定有針對性的行銷策略'
      },
      SmartCustomerService: {
        znkftd: '智慧客服特點',
        rgznjs: '基於強大的人工智慧技術',
        yyfxnl: '精准的語義分析能力，準確判斷用戶意圖',
        dhwdnl: '流暢自然的中文對話問答能力',
        zwxxnl: '豐富的上下文場景及強大的自我學習能力',
        zskxt: '強大的智慧知識庫系統',
        jrfa: '提供最優的接入方案',
        dhty: '對話體驗',
        lczrlx: '流暢自然領先的增強學習模型，讓客服機器人聊天對話更接近真人情感交互23類情緒識別及多維情感表達，讓機器人更擬人化記憶系統通過深度記憶系統與使用者畫像，讓機器人更懂你',
        lxjs: '領先技術',
        yyljkf: '語義理解開放域聊天準確率81.64%，垂域技能準確率96.34%知識圖譜千萬級實體及關係知識，支援邏輯與關係的知識推理多輪對話開放域聊天與垂域技能超過5輪的上下文對話能力',
        sjyl: '數據語料',
        jcltk: '基礎聊天庫通用對話語料150億條，兒童對話語料10億條基礎知識庫問答知識庫1億條，高頻知識庫1000萬條',
        hyrk: '智慧度高對話和語義準確度受到使用者及行業認可',
        ylkgn: '語料庫強大基於語義技術且支援批量上傳的語料庫功能',
        gglyl: '場景豐富能夠應用在網站、軟體及智慧硬體各個領域裡',
        jlqq: '回應快速毫秒級回應速度，輕鬆應對巨量請求',
        jnfw: '技能全面提供了涵蓋幾乎所有生活領域的技能服務',
        kfxns: '接入方便只需簡單的註冊啟動便可讓自己的產品成為客服小能手',
        sdyh: '針對多領域知識特點深度優化',
        ppnl: '快速精准的語料庫匹配能力',
        drygl: '方便快捷的語料庫導入與管理',
        yjcp: 'PC端可快速接入PC端、移動端及硬體產品',
        dzfsjr: 'APP支援API、SDK等多種方式接入',
        kfjqr: '後臺服務提供免費的虛擬客服機器人API'
      }
    },
    InternetBanking: {
      dsjypt: '電商交易平臺',
      zcglxt: '資產管理系統',
      wltrzpt: '網路投融資平臺',
      yhjglxt: '積分優惠劵管理系統',
      tyyxpt: '統一行銷平臺',
      yfkjypt: '電子預付卡交易平臺',
      wlxffqpt: '網路消費分期信貸平臺',
      AssetManagement: {
        zcglxt: '資產管理系統',
        gysgl: '資產管理系統由：供應商管理、設備台帳、設備檔案、設備維修、設備報廢、設備技術狀況、設備調撥、查詢管理、設備資料導入、系統管理組成。此管理系統覆蓋經營管理部門對固定資產的管理，將管理流程體系完全網路化、流程化。對設備進行綜合管理，達到的全面規劃、合理配置、優先選購、正常使用、安全運行、適時改造和更新。',
        ywjs: '業務介紹',
        cpgc: '產品工廠',
        gdcsh: '產品配置高度參數化,支援產品創新和聚合,能夠快速回應市場',
        flsch: '支持利率市場化/費率市場化',
        mxlc: '面向流程、服務的設計',
        jzcl: '支援作業集中處理，流程自動化、精簡化',
        bjdywfw: '一站式不間斷業務服',
        xsfu: '支援7×24小時服務',
        qfw: '全方位風險控管',
        czgk: '支持基於工作流的操作管控',
        gfktz: '規範可拓展的IT架構',
        zjhsj: '基於SOA架構的元件化設計，易於業務的分拆和組合，滿足業務擴張',
        yjtz: '支援跨平臺部署，保障硬體投資'
      },
      EcommerceTransaction: {
        kjdszf: '跨境電商支付解決方案',
        fzxz: '跨境電商支付發展現狀：跨境電子商務的定義主要由兩部分構成，第一，來自不同國家的交易雙方在進行支付結算時借助互聯網平臺，第二在商品的流通方面主要通過跨境物流進行運輸，這種交易形成的跨國商業活動便是跨境電商。我國跨境電商發展的前期，通關物流與相關的結算方式是線上交易的主要結算形式，比如傳統的郵政匯款，或是銀行轉帳，同時信用證也是主要方式。最近幾年以來，伴隨電子商務的發展，出現了大批包裹海外倉轉運模式，同時協力廠商支付平臺也在不斷完善發展中，信用卡支付、郵政匯款、銀行轉帳多種支付方式也在不斷創新發展中。在國家政策支持下，我國跨境電商發展保持快速增長態勢。',
        kdwt: '解決跨境電商微信開店問題'
      },
      ElectronicPrepaidCard: {
        dzyfk: '電子預付卡交易平臺',
        fwgjzl: '服務國家戰略、引領行業發展、助力門店升級，以顧客經營為中心，再創會員行銷新輝煌。全國領先的線上線下會員行銷、非會員顧客經營一站式解決方案服務商，為各行業商家提供市場最具競爭力的電子會員管理系統助力門店擁抱互聯網，提高營業額，提升競爭力',
        cpys: '產品優勢',
        fwjh: '服務計畫',
        xfsy: '消費收銀',
        mydhf: '滿意度回訪',
        yltk: '引流拓客',
        hyyx: '會員行銷',
        gklc: '顧客留存',
        wxqf: '微信群發',
        zngj: '智能跟進'
      },
      InternetConsumption: {
        wlxf: '網路消費分期信貸',
        fqxdxt: '網路消費分期信貸系統是一款基於大資料智慧風控的小額信貸系統，通過整合各種智慧化工具、資料、通信、規則實現自動進件、自動審批、自動放款、自動還款、自動催收等環節，使信貸業務的開展實現智慧化、可控化、簡單化、快速化。此款系統適用於極速貸、發薪日貸、零用貸、消費貸款等所有脫離於場景的小額現金貸款。系統內置一整套信貸風控體系，即使您沒有做過貸款類業務，不知道如何風控，通過使用互融雲現金貸業務也可以快速開展。如果您想擴展業務，我們還為您提供了標準的介面，與P2P對接、與引流平臺對接、與車貸、抵押貸業務整合等，都可以通過這套系統實現。',
        xtts: '系統特色',
        gnjg: '功能結構'
      },
      OnlineInvestment: {
        trzpt: '網路投融資平臺',
        cqyd: '存錢越多，收益越多收益每天累計增加帳戶餘額隨用隨取，安全便捷零風險',
        tstz: '天使投資',
        gqtz: '股權投資',
        zqtz: '債券投資'
      },
      PointCouponManagement: {
        yhjgl: '積分優惠券管理系統',
        cpdz: '01.從產品制定到方案策劃',
        jjqy: '解決企業禮品單一,缺乏吸引力的問題為企業打造行銷新模式',
        hdjf: '02.獲得積分',
        glyh: '鼓勵用戶與企業交互/拉動消費',
        xfjf: '03.消費積分',
        tskh: '提升客戶對品牌的信任感,增強客戶滿意度',
        wdcp: '我的產品',
        sczb: '01.市場轉播 增加客戶量',
        sjwl: '品牌與社交網路同步、擴大銷售和市場、提高和知名度形式新穎多樣，在客戶瞭解購買產品，對企業有一定的瞭解，幫助企業做出推廣，推薦介紹新客源，充分利用平臺積分和會員體系，靈活分配資源',
        dqd: '多管道精准引流',
        whkh: '02.維護客戶，提供完整的品質服務',
        jllh: '建立良好的信譽度，傾聽客戶意見，想客戶所想，急客戶所急，做好售後服務，完善功能需求，視產品品質到運營服務為平臺的第一位',
        jsgj: '及時跟進/用心傾聽',
        yxhd: '03.行銷活動創意多樣，貼近品牌',
        cydy: '節日行銷、會員活動豐富多樣，增強客戶參與度',
        yhjfgl: '04.優化積分管理',
        ppqyyh: '匹配企業用戶特性，進行積分分類管理，刺激客戶有目標進行消費，留存客戶提高行銷轉化率',
        yhzcd: '提升用戶忠誠度'
      },
      UnifiedMarketing: {
        tyyx: '統一行銷平臺',
        fwpt: '統一行銷服務平臺以供應鏈系統為支撐，是基於現代互聯網技術的多管道模式統一行銷服務管理體系。整合線上與線下交易模式，覆蓋企業經營管理應用各個方面。統一行銷服務管理能有效掌控通路情況，敏捷捕捉消費者需求，快速回應市場變化，規避經營風險；以市場為導向，優化部署行銷資源，協同產銷、供應與服務，説明企業構建敏捷的經營管理平臺；通過電子商務等創新通路模式整合流通企業上下游產業鏈資源，共用資料與服務，提升供應鏈效率。',
        tgtx: '市場推廣體系',
        djsc: '搭建市場競爭情報系統，為市場推廣奠定基礎精細化行銷活動與費用管理',
        ywtx: '行銷業務體系',
        sxcw: '實現財務物流商務一體化和產銷一體化、多管道整合平臺實施客戶全生命週期與高效物流執行管理平臺',
        zxtx: '銷售執行體系',
        tdjh: '基於團隊計畫、活動、培訓等的協同工作平臺基於路線規劃、拜訪計畫、移動銷售的銷售執行平臺',
        gxtx: '客戶關係體系',
        glyypt: '搭建消費者與會員管理運營平臺，提供差異化服務整合呼叫中心、ICC、MA、Ec等多 接入服務平臺',
        fxtx: '決策分析體系',
        znfxpt: '為行銷團隊打造智慧分析平臺為管理者打造決策支援平臺'
      }
    },
    NewPayment: {
      ydzf: '移動支付',
      hlwzf: '互聯網支付',
      kjzf: '跨境支付',
      dzqbzf: '海外電子錢包支付',
      fxpt: '統一分銷平臺',
      glpt: '統一商戶管理平臺',
      CrossborderPayment: {
        kjzffz: '跨境支付發展',
        xqbdts: '隨著人們跨境消費的需求不斷提升以及相關政策的逐步規範化，跨境支付有望迎來快速增長，伴隨著應用場景的擴容以及盈利模式的多樣化，預計到2020年行業容量將接近200億元。同時從行業格局看，跨境支付牌照的壁壘正在弱化，不同支付企業提供的支付服務模式也在分化。',
        zyyycj: '當前跨境支付的主要應用場景集中在跨境電商、跨境旅遊以及留學教育等三個領域，截至2015年這三個領域本身的市場規模分別達到了5.4萬億、1.2萬億和0.42萬億元，隨著這三個領域的進一步擴容以及跨境支付向其他領域的拓展，我們保守估計到2020年跨境支付行業通過收取手續費達到的市場容量將達到197.9億元。同時行業的盈利模式也將逐步多樣化，由過去的以手續費為主向手續費、供應鏈金融、綜合一體化方案等多種盈利模式演進。',
        kjzftd: '跨境支付特點',
        kjzfsy: '跨境支付屬於電子支付方式的一種，因而具有電子支付的特徵，但因其與移動通信技術、無線射頻技術、互聯網技術相互融合，又具有自己的特徵。',
        ssxd: '1.隨身攜帶的移動性，消除了距離和地域的限制。結合了先進的移動通信技術的移動性，隨時隨地獲取所需要的服務、應用、資訊和娛樂。',
        bssjdd: '2.不受時間地點的限制，資訊獲取更為及時，使用者可隨時對帳戶進行查詢、轉帳或進行購物消費。',
        ydtxjs: '3.基於先進的移動通信技術和簡易的手機操作介面，使用者可定制自己的消費方式和個性化服務，帳戶交易更加簡單方便。',
        ysjwzt: '4.以手機為載體，通過與終端讀寫器近距離識別進行的資訊交互，運營商可以將移動通信卡、公交卡、地鐵卡、銀行卡等各類資訊整合到以手機為平臺的載體中進行集成管理，並搭建與之配套的網路體系。',
        sydq: '適用地區：中國遊客目的地',
        hzyq: '合作要求：當地有支付、收單受理資質',
        sycj: '使用場景',
        wscp: '完善的產品',
        aq: '安全'
      },
      DistributionPlatform: {
        cpdy: '產品定義',
        tyyxfw: '統一行銷服務平臺以供應鏈系統為支撐，是基於現代互聯網技術的多管道模式統一行銷服務管理體系。整合線上與線下交易模式，覆蓋企業經營管理應用各個方面。統一行銷服務管理能有效掌控通路情況，敏捷捕捉消費者需求，快速回應市場變化，規避經營風險；以市場為導向，優化部署行銷資源，協同產銷、供應與服務，説明企業構建敏捷的經營管理平臺；通過電子商務等創新通路模式整合流通企業上下游產業鏈資源，共用資料與服務，提升供應鏈效率。',
        ywjs: '業務介紹',
        yxhd: '行銷活動',
        gjqy: '可以根據企業的經營目標和策略，兼顧各市場的差異性，實現市場活動的計劃性  。按不同的市場活動要求，根據活動的範圍、活動的物件，活動的目標建立相應的業務流程。根據不同的區域、不同的品種、不同的管道及終端建立有差別的審批機制。對活動的有效監督。提高活動效率，避免虛假行為。',
        khfw: '客戶服務',
        ckhy: '對持卡會員提供全服務過程追蹤，記錄服務過程中服務生命週期狀態變化情況;根據服務類型、服務週期、服務過程損耗和人員投入等資訊回饋，促進對會員卡產品制定、會員卡分級管理、會員卡續約政策、會員服務過程改進等多方面優化和完善。',
        ckps: '倉庫配送',
        wlwl: '支援物流網路的規模化的協同運作，提升供應鏈物流運作柔性，適應滿足物流產業複合性特點，提高物流網路運作的即時性和整體效益;支援物流網路的規模化的協同運作，提升供應鏈物流運作柔性，適應滿足物流產業複合性特點，提高物流網路運作的即時性和整體效益。',
        jtyx: '集團行銷',
        xsyw: '通過銷售業務政策管理、業務流程規範、商務協同應用，幫助構建集團企業銷售與分銷業務經營管理平臺，提升經營績效，優化資源配置，滿足客戶需求，降低運營成本。',
        dzsw: '電子商務',
        yyty: '用友統一行銷平臺提供B2B電子採購、B2B、B2C電子銷售等全程 電子商務解決方案，為商業創新企業提供E+E：(電子商務EC+ERP)、O+O：(線上Online+線下Offline)'
      },
      EwalletPayment: {
        hwdzqb: '海外電子錢包支付解決方案',
        jrfw: '海外電子錢包金融服務（支付）平臺就是互聯網技術和金融功能的有機結合，包括基於網路平臺的金融市場體系、金融服務體系、金融組織體系、金融產品體系以及互聯網金融監管體系等，並具有平臺金融、資訊金融和碎片金融等相異于傳統金融的金融模式。',
        jrzc: '海外電子錢包金融服務(支付)平臺最終發展為集成金融眾籌、金融流通（支付、轉帳、提現）、金融收益、金融清結算、金融信貸、金融分控等閉環金融生態圈，切實改變廣大人民的消費、理財、購物等生活方式，實現海外國家利益再分配，最終實現集團、廣大人民、海外國家等雙贏。',
        rz: '融資',
        tzlc: '投資理財',
        yx: '行銷',
        shjf: '生活繳費',
        xyk: '信用卡',
        xfzf: '消費支付',
        xyzf: '信用支付',
        zjgl: '資金管理',
        kh: '客戶',
        ff: '豐富',
        ht: '互通',
        jz: '集中',
        gl: '關聯',
        lh: '靈活',
        yq: '要求',
        ykhwzx: '以客戶為中心',
        zhjzgl: '帳戶集中管理',
        zhjrfw: '綜合金融服務',
        ydx: '移動性',
        dzh: '定制化',
        jsx: '及時性',
        jcx: '集成性'
      },
      InternetPayment: {
        zffz: '互聯網支付發展',
        hlwzy: '網銀、協力廠商支付、移動支付作為互聯網支付的主要表現形式。互聯網支付就屬於那種需要特別“照顧”的。因為從微觀層面上說，互聯網支付直接涉及到用戶的財產安全等切身利益，從宏觀層面上，還關係到國家金融體系的穩定。例如協力廠商支付公司擁有巨額的沉澱資金，獲得了開展金融業務的潛在能力，能夠對整個金融體系產生影響。從保證國家金融安全的角度看，政府監管肯定是必要的。',
        bkbm: '當支付遇到互聯網，一場革命自然不可避免。成為現實的是傳統的現金支付已經“退居二線”，各種線上支付方式成為人們日常消費的主要支付方式。銀行推出的網銀以及民營企業推出的各種各樣的協力廠商支付平臺大大方便了人們的生活，互聯網支付終端也從桌面電腦擴展到移動終端和電視等多種形式的終端上，互聯網支付變得無處不在。',
        zftd: '互聯網行業支付特點',
        zjdtx: '互聯網支付屬於電子支付方式的一種，因而具有電子支付的特徵，但因其與移動通信技術、無線射頻技術、互聯網技術相互融合，又具有自己的特徵。',
        ydx: '1.隨身攜帶的移動性，消除了距離和地域的限制。結合了先進的移動通信技術的移動性，隨時隨地獲取所需要的服務、應用、資訊和娛樂。',
        bssj: '2.不受時間地點的限制，資訊獲取更為及時，使用者可隨時對帳戶進行查詢、轉帳或進行購物消費。',
        jdfb: '3.基於先進的移動通信技術和簡易的手機操作介面，使用者可定制自己的消費方式和個性化服務，帳戶交易更加簡單方便。',
        sjwzt: '4.以手機為載體，通過與終端讀寫器近距離識別進行的資訊交互，運營商可以將移動通信卡、公交卡、地鐵卡、銀行卡等各類資訊整合到以手機為平臺的載體中進行集成管理，並搭建與之配套的網路體系。',
        sycj: '使用場景',
        dcb: '低成本',
        zfqd: '完善的支付管道接入，商家可以避免重複接入支付方式的巨大成本。',
        gx: '高效',
        jsjg: '收款即時有結果。',
        lhxg: '靈活性高',
        ywtd: '商家可根據自身的業務特點，對我們提供的支付能力進行靈活組合滿足業務需要。',
        ds: '電商',
        wm: '外賣',
        wyc: '網約車'
      },
      ManagementPlatform: {
        shptgn: '商戶平臺功能',
        shpttd: '商戶平臺特點',
        mdgl: '門店管理',
        xzmd: '新增門店，配置口碑門店ID，管理門店資訊',
        yhgl: '用戶管理',
        xzyg: '新增員工，設置每個員工所屬門店、角色以及不同許可權',
        lsgl: '流水管理',
        ghyy: '商戶可清楚瞭解每日資金流水，管理每個門店流水情況，瞭解門店經營情況，更好運營',
        cpgl: '產品管理',
        gzhgl: '申請公眾號管理、大屏互動、打賞等各類行銷產品並制定設置各個行銷產品具體內容',
        lssj: '流水資料更清晰',
        ssck: '即時查看每筆訂單，統計門店流程資料，資料圖片清晰直觀',
        cpzc: '多種行銷產品支援',
        hdyx: '公眾號管理、大屏互動遊戲、打賞管理等支持商戶更有效開展活動',
        zjjg: '多級組織架構',
        sjzb: '商家總部、商家門店多級組織統一管理，支援多級自訂設置'
      },
      MobilePayment: {
        ydzffz: '移動支付發展',
        ydzf: '移動支付也稱為手機支付，就是允許使用者使用其移動終端（通常是手機）對所消費的商品或服務進行賬務付的一種服務方式。單位或個人通過移動設備、互聯網或者近距離傳感直接或間接向銀行金融機構發送支指令產生貨幣支付與資金轉移行為，從而實現移動支付功能。移動支付將終端設備、互聯網、應用提供商及金融機構相融合，為用戶提供貨幣支付、繳費等金融業務。',
        dzgz: '移動支付標準的制定工作已經持續了三年多，主要是銀聯和中國移動兩大陣營在比賽。資料研究公司IDC的報告顯示，2017年全球移動支付的金額將突破1萬億美元。強大的資料意味著，今後幾年全球移動支付業務將呈現持續走強趨勢。',
        zftd: '互聯網行業支付特點',
        zffs: '移動支付屬於電子支付方式的一種，因而具有電子支付的特徵，但因其與移動通信技術、無線射頻技術、互聯網技術相互融合，又具有自己的特徵。',
        ydx: '1.隨身攜帶的移動性，消除了距離和地域的限制。結合了先進的移動通信技術的移動性，隨時隨地獲取所需要的服務、應用、資訊和娛樂。',
        bssj: '2.不受時間地點的限制，資訊獲取更為及時，使用者可隨時對帳戶進行查詢、轉帳或進行購物消費。',
        jdfb: '3.基於先進的移動通信技術和簡易的手機操作介面，使用者可定制自己的消費方式和個性化服務，帳戶交易更加簡單方便。',
        sjwzt: '4.以手機為載體，通過與終端讀寫器近距離識別進行的資訊交互，運營商可以將移動通信卡、公交卡、地鐵卡、銀行卡等各類資訊整合到以手機為平臺的載體中進行集成管理，並搭建與之配套的網路體系。',
        sycj: '使用場景',
        dzh: '定制化',
        jsx: '及時性',
        jcx: '集成性'
      }
    }
  },
  // IT服務
  ITservice: {
    index: {
      fw: 'IT 服務',
      jsfw: 'IT 技術服務',
      yyzcfw: 'IT 運營支撐服務'
    },
    IToperative: {
      kjzfyy: '跨境支付運營',
      jhzfyy: '聚合支付運營',
      zjcgyy: '資金存管運營',
      kjdsyy: '跨境電商運營',
      AggregatePayment: {
        jgzftd: '聚合支付特點',
        bzsh: '幫助商戶更好地提升收銀效率，優化商戶與支付通道的對接過程，為商戶提供快捷、安全、可靠的支付服務，還將日常交易管理、查帳對賬、商品管理等集成到統一的管理平臺，大大提高了商戶運營效率。',
        ywjs: '業務介紹',
        hlwjr: '互聯網金融平臺的建設，打破原有的封閉體系，幫助銀行轉型，融入互聯網生態。',
        spfw: '商品服務',
        sh: '商戶',
        xsjhzf: '線上聚合支付',
        yh: '用戶',
        dzqs: '對賬清算',
        xxjhzf: '線下聚合支付',
        zfcp: '支付產品',
        jgzfpt: '聚合支付平臺',
        cpys: '產品優勢',
        dcjgl: '多層級管理',
        zcpt: '支援平臺、運營公司、代理商、商戶多層級業務運營、滿足企業業務拓展需求。',
        dyhzf: '多元化支付',
        zcdzcj: '支持多種場景，即可進行互聯網及移動平臺支付結算，也可線下面對面掃碼支付、刷卡支付，後臺接入了多方支付通道。',
        dwdtj: '多維度統計',
        dycp: '多元產品具備完整的交易資料統計查詢模組，能夠從不同維度進行交易資料統計，為商戶代理商及運營平臺提供強大的資料支撐化支付。',
        zddz: '自動對賬',
        yygs: '支援平臺、運營公司、代理商、商戶多層級業務運營、滿足企業業務拓展需求。'
      },
      CrossborderEcommerce: {
        kjdste: '跨境電商特點',
        hyfx: '行業分析',
        zgqjsn: '在過去十幾年中，電商行業在國內的發展一直處於上半場，這一方面來自於線民數量的增加，另一方面，消費者從線下轉到線上的消費需求，通過電商找到出口得到更好的滿足。現在電商平臺更加多樣化，更加興趣化。比如:最典型的社交紅人大V變現之路，他們在平臺上充分互動，從而在平臺中產生爆發性的銷售高峰。',
        ywjs: '業務介紹',
        zgdyp: '中國第一批代購跨境電商，連接跟代購有關的一切。',
        cpdw: '產品定位',
        mzyx: '滿足一些使用者需要購買境外的產品需求，以境外線下店鋪為主，提供高品質購物的同時，提供了買手服務。',
        spfk: '商品付款',
        qrdgdd: '確認代購訂單',
        wcdd: '完成訂單',
        zf: '支付',
        fh: '發貨',
        ms: '買手',
        kh: '客戶',
        hqpt: 'HQ平臺',
        dd: '訂單',
        jh: '交貨',
        qh: '取貨',
        spje: '商品金額',
        dbje: '擔保金返還/代購費',
        sj: '商家',
        cpys: '產品優勢',
        xsgl: '銷售管理',
        kfzx: '客服線上服務',
        gxck: '高效倉庫',
        fxsj: '分析資料',
        gzl: '工作流',
        shcl: 'CRM售後處理',
        ckgl: 'FBA倉庫管理',
        ddlr: '訂單利潤',
        gnxzs: '功能小助手'
      },
      CrossBorderPayment: {
        kjzftd: '跨境支付特點',
        hlwkjzf: '互聯網跨境支付業務全面整合了中國銀聯、境內發卡銀行和境外主流銀行卡收單服務機構三方資源，具有商戶資源全球覆蓋、交易支付安全便捷、業務流程統一規範等顯著特點，深受廣大銀聯卡持卡人信賴',
        zc: '註冊',
        sk: '收款',
        tx: '提現',
        cpys: '產品優勢',
        aqhg: '安全合規',
        ysgg: '嚴守各國當地金融法規確保資金安全，收款無憂',
        jdhs: '降低匯損',
        ygnzl: '與國內主流商業銀行“現匯買入價”相比，匯率更具優勢',
        txxs: '提現迅速',
        yzk: '以最快的速度將款項匯至您的帳戶',
        czbj: '操作便捷',
        dpt: '多平臺、多帳戶統一管理商戶後臺即時查看到賬資訊',
        sfyh: '收費優惠',
        sxf: '手續費具有競爭優勢收費透明，無隱形費用',
        xyjs: '回應及時',
        zrkf: '專人客服7*24小時即時回應'
      },
      DepositoryOperations: {
        zjcgyy: '資金存管運營',
        zjcgsz: '資金存管是指銀行對合作平臺出借人與借款人開立和使用的資金存管帳戶進行管理和監督，依照出借人與借款人向平臺發出的指令，對兩者資金進行存管、劃付、核算和監督，平臺作為純粹的資訊仲介參與到交易之中，全程不觸碰資金，所有資金流動均在銀行體系內進行，從而真正做到了平臺與用戶資金完全隔離，有效杜絕了平臺支配和挪用用戶資金的風險。',
        qdmmht: '簽訂買賣合同',
        djzfjk: '對接支付介面',
        wccgjr: '完成存管接入',
        sycggn: '使用存管功能',
        cgyh: '存管銀行',
        qdxy: '簽訂協定',
        ktcgzh: '開通存管帳戶',
        cpys: '產品優勢',
        ywcj: '業務場景精確匹配',
        djdjyh: '對接多家銀行存管產品，根據電商、直播、餐飲、眾籌等行業的業務場景，為商戶精准匹配資金存管銀行，提供最契合的資金存管方案。',
        wxecjr: '無需二次接入',
        djhqpay: '對接HQPAY資金存管解決方案，可在支付交易成功的同時，自動完成存管帳戶內的資金及賬務資訊同步，無需重複接入。',
        zytdxy: '專業團隊極速回應',
        hylx: '行業領先的產品、技術、客戶成功團隊極速回應，有效降低企業的時間和人力成本。'
      }
    },
    ITtech: {
      appkf: 'APP開發',
      xcx: '小程式',
      rjdzkf: '軟體定制開發',
      kflc: '開發流程',
      AppDevelopment: {
        cpdy: '產品定義',
        bzqy: '幫助企業開發安卓和蘋果應用，更有針對性在移動互聯網搶佔先機，奪取市場。APP創新性開發，始終是用戶的關注焦點，而商用APP用戶端的開發，在傳統廣告、傳統互聯網與移動互聯網融……',
        cpys: '產品優勢',
        kfal: '開發案例',
        slkk: '實力可靠',
        kfgs: '開發公司專案參與人員的綜合素質、技術人員的技術是否過硬、是否有代表性案例等等，這些都能體現一個APP開發公司的綜合實力。',
        chnl: '策劃能力',
        gszlj: '公司在瞭解客戶行業背景和App功能需求後，能否短期內迅速反應，拿出有價值有創意的策劃方案，這是個App開發公司策劃能力的體現。',
        xylh: '信用良好',
        kytg: '可以通過多種管道去瞭解某個APP開發公司的信譽、口碑，是否有過不良記錄等。',
        fwyz: '服務優質',
        rgs: '如果說雄厚的技術是個APP開發公司的硬實力，那麼優質的服務就是其軟力的體現。APP開發前期的溝通往往需要甲乙雙方的溝通配合才能完成。',
        ptwt: '平臺穩妥',
        kfgsxm: '開發公司專案參與人員的綜合素質、技術人員的技術是否過硬、是否有代表性案例等等，這些都能體現一個APP開發公司的綜合實力。'
      },
      DevelopmentProcess: {
        gt: '溝通',
        sj: '設計',
        kf: '開發',
        cs: '測試',
        jf: '交付',
        wh: '維護'
      },
      SmallApp: {
        xcxkf: '小程式開發',
        xcxs: '小程式是從微信中打開的APP，無需安裝，用完即走。可以解決消費者因使用APP成本過高而不買帳的問題，同時多一條路徑觸達消費者。',
        cpys: '產品優勢',
        kflc: '開發流程',
        qqgt: '前期溝通',
        xqpg: '需求評估',
        uigh: 'UI規劃',
        gngh: '功能規劃',
        sjsj: '視覺設計',
        qdzz: '前端製作',
        jskf: '技術開發',
        cs: '測試',
        wcjf: '完成交付',
        cskj: '觸手可及',
        bxyxz: '小程式不需要下載安裝，使用者掃一掃或者搜一下即可打開',
        gnff: '功能豐富',
        ksxdw: '可實現定位、語音、視頻、IM聊天、重力感應、導航等與原生APP一樣的功能',
        ywjz: '用完即走',
        yhbgx: '用戶不用關心是否安裝太多應用的問題小程式隨時可用，又無需安裝卸載',
        fxhl: '分享紅利',
        fbfx: '小程式可方便分享到微信個人和群聊視窗，回話中點擊即用，非常方便傳播',
        xsxxdt: '線上線下打通',
        zjrk: '小程式最佳入口是掃描二維碼，線下用戶只需簡單掃碼，即可轉換為小程式使用者',
        yhtx: '開放的用戶體系',
        wxdr: '小程式無需登錄，直接採用微信帳號體系，極大降低用戶首次使用門檻，同時方便使用者資訊收集'
      },
      SoftwareCustomization: {
        rjdzkf: '軟體定制開發服務',
        gjkhxq: '可根據客戶的需求，量身定制一系列符合客戶實際應用的軟體。目前的多數資訊管理軟體可以滿足行業內的通用需求，而在特殊流程和客戶定制上成本很高。對於中小企業來說,可以根據自己的實際業務需求，定制開發一套適合自己的軟體。開發不求一步到位，一步步進行完善。如此，可以減少投入，並非常適合自身業務發展。',
        dzdjz: '定制的價值',
        ksld: '快速落地方案',
        qmfg: '全面覆蓋需求',
        jzdw: '精准定位方向',
        zyln: '貫徹專業理念',
        wmdys: '我們的優勢',
        zdxq: '針對性強',
        dzrj: '定制軟體因為是量身定做的所以針對性非常強這也是定制軟體最大優勢',
        xjbg: '性價比高',
        dzkf: '定制開發的軟體較於購買的通用型軟體更具高性價比,更專業適用',
        gxlx: '高效率性',
        gjqy: '根據企業需求專業定制的軟體，在操作使用方面更加的方便和快捷，提高了效率',
        kkzx: '可拓展性',
        rjxt: '軟體系統可運行在開源平臺或商業平臺上，井且可應用多種成熟的開源系統架構'
      }
    }
    //
  },
  // 合作夥伴
  CooperativeTranslation: {
    ryzs: '榮譽證書',
    hzhb: '合作夥伴',
    gxjsqy: '高新技術企業證書',
    qyxydj: '企業信用等級證書',
    cmmi: 'CMMI認證證書',
    xxaq: '信息安全管理體系認證證書',
    zlgl: '質量管理體系認證證書',
    xxaqgl: '信息安全管理體系認證證書'
  },
  // 關於泓齊
  AboutUs: {
    nav: {
      qywh: '優秀的企業文化',
      fwtd: '一流的服務態度',
      jstd: '專業的技術團隊',
      zzgc: '精細的製作流程'
    },
    company: '泓齊網絡科技有限公司',
    p1: '泓齊網科成立於2017年3月,',
    p2: '由崇尚極致、追求創新的團隊打造而成，',
    p3: '專業為國內外金融機構',
    p4: '提供高效技術支持、優質咨詢服務',
    p5: '的創新型公司。',
    p6: '以互聯網金融創新服務為目標，緊跟國家「一帶一路」發展戰略，',
    p7: '力',
    p8: '求把先進的產品理念、精湛的技術和良好的服務帶給全球客戶。',
    p9: '業務分布',
    p10: '中國大陸、港澳臺、東南亞及非洲地區等地',
    p11: '公司始終秉承「專業、專註、專家」的理念，打造令用戶滿意、合作夥伴信任、公司健康成長、員工快樂工作的持續性發展公司。面對未來，我們將以「安全、高效、優質」為發展宗旨，不斷追求行業信息技術應用的創新，成為全球移動支付和金融科技行業服務價值的創造者與領先者。',
    p12: '我們',
    p13: '的',
    p14: '理念',
    gyhq: '關於泓齊',
    szhq: '深圳市泓齊網路科技有限公司(簡稱：HQPAY)成立於2017年3月，由崇尚極致、追求創新的團隊打造而成，是',
    yjzy: '一家專業為國內外金融機構提供高效技術支援、優質諮詢服務的創新型公司。',
    yhlw: '以互聯網金融創新服務為目標，緊跟國家“一帶一路”發展戰略，公司業務目前主要分佈中國大陸、港',
    atdny: '澳台、東南亞及非洲地區等地，力求把先進的產品理念、精湛的技術和良好的服務帶給全球客戶。',
    yxqy: '優秀的企業文化',
    ylfw: '一流的服務態度',
    zyjs: '專業的技術團隊',
    jxzz: '精細的製作流程',
    azkf: 'Android開發工程師',
    azkf1: '具有大型互聯網用戶端APP或各類SDK開發經驗;',
    azkf2: '精通Android開發，瞭解Android框架對Android系統應用管理、進程管理、記憶體管理等機制有深入理解;',
    azkf3: '熟悉Spring Cloud等Java開源框架，熟練AIDL，NDK開發深入理解物件導向的設計思想，常用設計模式;',
    azkf4: '熟練掌握TCP/IP/UDP，http，https等網路通訊協定;',
    azkf5: '3-5年互聯網金融App相關專案經驗;',
    azkf6: '3-5年互聯網金融App相關專案經驗;',
    azkf7: '有大型APP架構設計經驗經驗者優先。',
    qdkf: 'Web前端開發工程師',
    qdkf1: '本科及以上；畢業證滿一年',
    qdkf2: '1年以上前端工作經驗，扎實的JavaScript基本功，精通BOM，DOM，HTML5,CSS3； 熟悉使用React',
    qdkf3: '在實際專案中，有過ReactNative開發經驗 ，具有前後端分離經驗，良好的編碼習慣',
    qdkf4: '熟練使用webpack； 瞭解前端性能調優； 熟練使用Git。 最近半年內必須使用React技術棧開發',
    qdkf5: '具備良好的團隊協作精神，能利用自身技術能力提升團隊整體研發效率',
    qdkf6: '對技術有激情，喜歡鑽研，能快速接受和掌握新技術，有較強的獨立、主動學習能力，良好的溝通表達能力和團隊協作能力',
    jakf: 'JAVA開發工程師',
    jakf1: '本科及以上學歷，3年以上工作經驗，電腦、軟體工程、資訊系統等相關專業',
    jakf2: '3年及以上JAVA經驗，熟悉Spring,Struts,iBatis及至少一種Java 應用伺服器如tomcat,jetty',
    jakf3: '3年以上互聯網行業大型企業應用系統開發相關經驗，扎實的基礎知識。有高併發及億級資料項目目經驗優先',
    jakf4: '熟練掌握MYSQL或Oracle等資料庫技術,具有資料庫使用調優能力。熟悉mongodb、tidb者優先',
    jakf5: '熟悉服務化框架，如springcloud,tinygroup,webservice，hessian，dubbo等',
    jakf6: '熟悉Linux常用命令，能獨立在上面進行開發，測試和部署',
    jakf7: '有良好的溝通能力和較強的責任心和學習能力',
    jakf8: '熟悉雲框架以及分散式應用系統設計開發',
    jakf9: '有良好編碼規範及文檔編寫習慣',
    zpzg: '招聘主管',
    zpzg1: '具有大型互聯網公司人事工作經驗優先',
    zpzg2: '熟悉人力資源六大模組，精通招聘模組以及員工關係管理',
    zpzg3: '具備較好的表達、溝通、組織、協調能力和時間管理能力',
    zpzg4: '執行力強，願意不斷學習並提升自己的綜合技能',
    zpzg5: '良好的宏觀把握及大局觀、系統管理、團隊建設能力，優秀的制度建設及推進能力，計畫、組織、統籌、協調、溝通、激勵能力強',
    zpzg6: '具備良好的學習能力、執行力和抗壓能力',
    sjzy: '世紀之約-中秋遇國慶',
    sshq: '盛世泓齊 龍騰網科',
    lwb: '力王杯',
    jqdl: '激情點亮新年,歡樂盡在泓齊',
    rlqz: '熱烈慶祝泓齊網路科技有限公司喬遷之喜',
    gssz: '公司始終秉承“專業、專注、專家”的理念，打造令用戶滿意、合作夥伴信任、公司健康成長、員工快樂工作的持續性發展公司。面對未來，我們將以“安全、高效、優質”為發展宗旨，不斷追求行業資訊技術應用的創新，成為全球移動支付和金融科技行業服務價值的創造者與領先者。',
    qqyd: '全球移動支付',
    gszl: '公司致力於通過靈活穩定的業務經驗和技術架構，讓銀行和其他金融企業享有互聯網金融及支付領域的專業系統服務，互聯網金融及支付領域的專業系統服務。持續挖掘金融行業痛點，秉承“專注創造產品價值”的服務核心，積極推動技術、產品、使用者體驗等全方位創新，為客戶提供一站式產品、技術解決方案服務，致力於讓金融與互聯網產品結合的更為緊密。',
    hlwjr: '互聯網金融行業解決方案',
    szjj: '隨著經濟快速發展，中國出境游消費達千億美元，在整體旅遊營收中占比在不斷提升。為解決商家和銀行在支付和結算過程中遇到諸多不便的問題，公司致力於與海外、當地合法金融機構（銀行、清算組織、協力廠商支付機構）合作，共同發展全球移動支付業務。公司的業務支付場景，包括收銀系統，智慧POS，聚合二維碼台卡，線上支付等，支持各種複雜的業務場景，回應時間迅速，處理結果安全可靠，迎合了中小商戶和消費者群體的需求，以提供線上支付綜合解決方案的方式解決了支付場景“碎片化”的痛點。同時，公司致力於將中國的普惠金融理念帶向全球其他的國家和地區，結合當地的實際情況，聯合當地政府和企業，以科技為載體，提高了當地居民生活、工作的便利性。',
    zqygq: '世紀之約-中秋遇國慶 你準備好了嗎',
    hqwk: '泓齊網科',
    zzmnd: '在這麼難得的節日裡，我們相聚在一起，作為泓齊網科的大家庭肯定要琢磨著為家人們送點什麼來應應節？來，跟著小編往下看。',
    nywjjs: '你以為這樣就結束了嗎？',
    rwmjx: '讓我們繼續一探究竟……',
    smewm: "掃描上方二維碼關注'泓齊網科'微信公眾號",
    cjyx: '辭舊迎新，繼往開來',
    nrdjd: '2020迎新晚會於2020年01月11日在“南蓉大酒店”圓滿舉行',
    jxry: '吉祥如意，金鼠伴你旺一年，一年比一年甜！在這辭舊迎新的時節，泓齊網科2020迎新晚會於2020年01月11日在“南蓉大酒店”圓滿舉行。公司的年會凝聚了各高層領導以及公司所有員工的智慧與汗水，是全體員工對2019年豐富經驗的傳承和2020年戰略構想規劃，也是全體員工共聚一堂喜迎新春的歡聚晚會。',
    zwhs: '在晚會上，CEO從整體運營佈局的高度對公司2019年的工作總結，對2020年的工作作出了部署，使我們清晰的預測到未來工作中的機遇和挑戰，讓我們能夠更加從容的完成2020年的工作目標！',
    gszsyyg: '2019年，公司在所有員工的共同努力下，克服重重困難，齊心協力圓滿完成公司各項目標，湧現出很多優秀的管理者和優秀員工。作為員工學習的典範，公司對優秀管理者和優秀員工進行表彰，激勵優秀者以更加積極主動的工作態度、更加嚴謹負責的工作精神為泓齊網科發展添磚加瓦。',
    hqygdtj: '“盛世泓齊 龍騰網科”在迎新晚會集中體現了泓齊員工的團結、和諧、活潑、智慧的魅力，尤其是演員人的犧牲。員工在下班時間進行排練，他們經過無數個夜晚用心排練，不怕困難、艱辛付出，才有了我們這麼一場歡樂精彩的晚會。',
    ffyw: '回首2019年，我們奮發有為、碩果累累；展望2020年，我們機遇與挑戰並存、任重遠道。在新的一年裡，我們泓齊網科將繼續發揚團結拼搏、開拓創新的工作作風，繼續保持同心同德的合作精神，勇往直前的拼搏精神，以高度的責任感和強烈的事業心，百盡竿頭更進一步，再攀公司發展新高峰！',
    qhdyj: '慶賀第一屆泓齊網科“力王杯”奧運聯賽圓滿結束',
    wffyg: '為豐富員工文化生活，讓員工在緊張的工作之餘也放鬆心情，同時增強公司凝聚力，提高員工對優秀企業文化的共建鍛造和繼承，並為同事間相互交流、進一步認識提供機會，集體活動讓全體員工和管理人員陶冶情操、減輕壓力，激發熱愛生活、熱愛崗位的工作熱情，更讓大家進一步瞭解公司良好的發展態勢，增強熱愛勞務的熱情，堅定和公司同步成長、同步發展的信心。同時在活動過程中增進同事之間的溝通交流、友誼，加強瞭解、交流工作管理心得。培育企業團結、奮進的團隊精神，團隊成員的密切配合，特舉辦此次運動會。',
    ccydh: '此次運動會專案多多，趣味多多，領導也跟員工投身其中，現場氣氛熱烈而和諧，歡呼聲呐喊聲不斷，充分展現員工團結協作、積極向上、敢於拼搏的精神面貌。此次比賽項目有：吃西瓜、德州撲克、拖拉機撲克、跳棋、四國軍棋、象棋、五子棋、羽毛球單雙打、三人籃球、乒乓球、兩人三足、賽車、LOL。一共13個項目，有益智類、體能類和電競類三大項。集趣味性和競技性於一體，體現了員工們的積極配合和努力拼搏、不服輸的崇高精神。大家樂在其中，為享受運動的樂趣和爭得集體的榮譽揮灑青春的汗水。',
    jqss: '激情四射的運動場',
    lwbj: '力王頒獎典禮',
    lwsqtyg: '【泓網科技】力王賽全體員工2018年大合影',
    rlzh: '熱烈祝賀泓齊網科年會在清遠圓滿召開',
    qyfgb: '清遠佛岡碧 · 桂園 · 清泉城，吃著火鍋，品著美食，泓齊和鳴野的帥哥靚女們迎來了2018年年會的高潮 · 晚會，本次晚會安排了歌曲，小品，相聲，遊戲，抽獎等有趣的環節，節目精彩紛呈，高潮迭起，給在場的所有人帶來了一場別開生面的視覺盛宴。整個晚會氣氛活躍，讓員工在欣賞節目的同時，收穫一份感動，一份與企業心心相連的默契。',
    whcs: '晚會初始，泓齊網科CEO輝神發表新年賀詞，祝福大家新年快樂的同時預祝兩家公司在2018年紅紅火火、大展宏圖。並以一首《咱們屯裡的人》正式拉開晚會的帷幕。',
    sxdc: '首先登場的是爆笑又富有深刻寓意的小品《生活不止眼前的苟且》，眾多心懷夢想的年輕人從五湖四海彙聚到深圳，形成了深圳獨有的文化。幾乎每一個來深圳的人，都會被人問過這樣一句話：你為什麼來深圳？同樣，每一個離開深圳的人，也會被問到：你為什麼要離開深圳？《生活不止眼前的苟且》幫大家找到了答案！大家在為之笑容失控時卻又被觸動心弦。',
    zdjsk: '在大家思考的同時，晚會迎來了第二個節目《動口不動手》，參與遊戲的選手們紛紛展現出各自的默契與奇思妙想，充分展現了公司員工的合作與創新精神。',
    yxgh: '遊戲過後的抽獎環節，更是扣人心弦，緊張萬分，眾多員工抱得大獎。',
    zyzswd: '在一眾失望的眼神中，不一樣的《新聞聯播》登場了，在兩位主持人一本正經的唇槍戰後，帶領大家再一次掀起熱情的高潮。',
    zyphsxy: '在一片歡聲笑語中，迎來了此次晚會壓軸大戲 · 大型真人婚姻秀節目--《非誠勿擾》。伴隨著《非誠勿擾》主持人-輝神帥氣的發言，風靡全場的8位女嘉賓閃亮登場。她們展現著迷人的身姿，微微轉身，台下男嘉賓心裡早已按耐不住：“她轉身，如碧波伴清澈的眼神，洋溢這淡淡的溫馨，嘴角的弧度似月牙般完美，或許，這就是天使的微笑”。',
    zylld: '在一輪輪的男嘉賓展示自己魅力，表達自己真誠，卻又鎩羽而歸。正驗證了這麼一句話“我抬著丘比特的箭追呀追，你穿著防彈背心跑呀跑”。或許是丘比特箭丟了，他直接出手了，新一輪男嘉賓上場，一位女生到最後留燈了，男嘉賓的心動女生也正是這位女嘉賓，真是“身無彩鳳雙飛翼，心有靈犀一點通”。',
    xcbf: '現場爆發出一陣陣驚歎。在驚歎的同時，最後一位男嘉賓登場了，他同樣也被女嘉賓留燈，只是心動女生卻不是她，“我本將心向明月，奈何明月照溝渠”。',
    mhdsk: '美好的時刻總是短暫的。晚會中不論是喜氣洋洋的《咱們屯裡的人》還是趣味盎然的《生活不止眼前的苟且》、奇思妙想的《動口不動手》、時尚潮流的《新聞聯播》、真人秀的《非誠勿擾》、每一個都給大家帶來了無盡的歡樂。',
    zhyhs: '最後由輝神上臺，主持一等獎的抽獎，結束了2018年晚會。',
    bcwh: '本次晚會，在豐富了員工的文化生活，為員工提供了展示自己的舞臺之時，也增強了泓齊的內部凝聚力，增進了員工對公司的認知和歸屬感。相信在未來的2018年，我們鬥志昂揚！',
    wmbjl: '我們搬家了',
    rlqzhqwk: '熱烈慶祝泓齊網路科技有限公司喬遷之喜',
    wxdgzhj: '導語：全新的工作環境，頂尖的工作團隊，積極的工作態度……鑼鼓喧天、鞭炮齊鳴，2018年4月17日，泓齊網路科技有限公司，我們搬家啦！經過公司全體同仁的齊心努力，泓齊網科順利完成新址搬遷並恢復正常工作，由福田奧林匹克大廈搬遷至南山區桃源辦平山大園工業區13棟（鴻萊科創樓）4樓405室，泓齊網路科技有限公司，我們搬家啦！經過公司全體同仁的齊心努力，泓齊網科順利完成新址搬遷並恢復正常工作，由福田奧林匹克大廈搬遷至南山區桃源辦平山大園工業區13棟（鴻萊科創樓）4樓405室，泓齊網路科技有限公司，我們搬家啦！經過公司全體同仁的齊心努力，泓齊網科順利完成新址搬遷並恢復正常工作，由福田奧林匹克大廈搬遷至南山區桃源辦平山大園工業區13棟（鴻萊科創樓）4樓405室。',
    xbgs: '新辦公區寬敞明亮，環境怡人，一排排辦公桌整齊而典雅，一縷陽光穿梭而留，這悄然愜意的一面，正如我們這個年輕的團隊，創新今日，通向未來！新址所提供的更加現代化的辦公條件和更加先進的辦公設備為今後不斷壯大企業實力打下了堅實的基礎，也為年輕的我們提供了更好的戰場。',
    zqhy: '整齊劃一的辦公區',
    hys: '會議室',
    ygxxq: '員工休閒區',
    ccqq: '此次喬遷，標誌著泓齊網科從此又邁上了一個新的臺階，一次次辛勤的汗水換來的是一次次的飛躍。公司將以全新的面貌展現於同仁，以全新的理念和品質服務于我們的客戶！看今朝，我們躊躇滿志，展未來，我們豪情滿懷！我們將以更加飽滿的工作熱情，良好的精神狀態，打造泓齊網科全新的輝煌；以百倍的努力，共同創造美好未來！',
    gsdt: '公司動態',
    hqzp: '泓齊招聘',
    rzyq: '任職要求',
    lxwm: '聯繫我們',
    szshqwk: '深圳市泓齊網路科技有限公司（深圳公司總部）',
    gsdz: '公司地址：',
    gdsszs: '廣東省深圳市南山區桃源辦平山大園工業區13棟（鴻萊科創樓）4樓405室 518055',
    gsdh: '公司電話：',
    dl: '大陸',
    gsgw: '公司官網：',
    gsyx: '公司郵箱：',
    xggs: '香港公司',
    xg: '香港'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/zh-hk.js